<template>
  <div class="row">
    <div class="col">
      <Entete ref="header"/>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col">
          <h2 class="titre">
            Recherche
          </h2>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button class="pilotage-buttons" @click="redirectionRechercheIntervenants">
            Recherche des intervenants et profils
          </Button>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col">
          <h2 class="titre">
            Console de sécurité
          </h2>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button class="pilotage-buttons" @click="redirectionMatriceGroupes">
            Matrice des groupes
          </Button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button class="pilotage-buttons" @click="redirectionTabledesvaleurs">
            Table des valeurs
          </Button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button class="pilotage-buttons" @click="redirectionGroupesSecurite">
            Groupe de sécurité
          </Button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button class="pilotage-buttons"  @click="redirectionAttributionRolesGroupeSecurite">
            Attribution de rôles à un groupe de sécurité
          </Button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button class="pilotage-buttons" @click="redirectionCopieRolesGroupeSecurite">
            Copie de groupes
          </Button>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col">
          <h2 class="titre">
            Autres
          </h2>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button class="pilotage-buttons" @click="redirectionClassementDossiers">
            Classement des dossiers
          </Button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button class="pilotage-buttons" @click="redirectionClassementVilles">
            Classement des villes
          </Button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button class="pilotage-buttons" @click="redirectionFichiers">
            Fichiers
          </Button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button class="pilotage-buttons">
            Photos
          </Button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button class="pilotage-buttons" @click="redirectionInterventions">
            Interventions
          </Button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button class="pilotage-buttons" @click="redirectionMenuSite">
            Sites
          </Button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button class="pilotage-buttons">
            Aide en ligne
          </Button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button class="pilotage-buttons" @click="redirectionSequence">
            Séquence pilotage
          </Button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button class="pilotage-buttons" @click="redirectionMessageUtilisateur">
            Message utilisateur
          </Button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button class="pilotage-buttons">
            Historique
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Entete from '../../components/dashboard/Entete.vue';

export default {
  components: {Entete},
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Accueil Pilotage");
  },
  methods: {
    redirectionRechercheIntervenants() {
      this.$router.push({name: 'rechercherIntervenantPilotage'});
    },
    redirectionClassementVilles() {
      this.$router.push({name: 'classementVillesPilotage'});
    },
    redirectionClassementDossiers() {
      this.$router.push({name: 'classementDossierPilotage'});
    },
    redirectionFichiers() {
      this.$router.push({name: 'classementFichiers'});
    },
    redirectionInterventions() {
      this.$router.push({name: 'classementInterventions'});
    },
    redirectionSequence() {
      this.$router.push({name: 'sequence'});
    },
    redirectionMessageUtilisateur() {
      this.$router.push({name: 'rechercherMessageUtilisateur'});
    },
    redirectionMenuSite() {
      this.$router.push({name: 'menuSite'});
    },
    redirectionMatriceGroupes() {
      this.$router.push({name: 'matriceGroupesPilotage'});
    },
    redirectionTabledesvaleurs() {
      this.$router.push({name: 'TabledesvaleursPilotage'});
    },
    redirectionGroupesSecurite() {
      this.$router.push({name: 'groupesSecuritePilotage'});
    },
    redirectionAttributionRolesGroupeSecurite() {
      this.$router.push({name: 'rolesGroupeSecuritePilotage'});
    },
    redirectionCopieRolesGroupeSecurite() {
      this.$router.push({name: 'copieRolesGroupeSecuritePilotage'});
    },
  }
}
</script>
